const ISO_DATE = /^\d{4}-\d{2}-\d{2}(?:T(?:\d{2}):(?:\d{2})(?::(?:\d{2})(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:\d{2})?)?$/;

function isPlainDateOptions(value) {
  if (value === null || Object.prototype.toString.call(value) !== '[object Object]') return false;
  const prototype = Object.getPrototypeOf(value);
  return prototype === null || Object.getPrototypeOf(prototype) === null;
}

function toDate(value) {
  if (!(value instanceof Date) && typeof value !== 'number' && typeof value !== 'string') {
    throw new TypeError('date must be a valid Date, timestamp, or ISO date string');
  }
  if (typeof value === 'string' && !ISO_DATE.test(value)) {
    throw new TypeError('date must be a valid Date, timestamp, or ISO date string');
  }
  if (typeof value === 'number' && !Number.isFinite(value)) {
    throw new TypeError('date must be a valid Date, timestamp, or ISO date string');
  }

  const date = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  if (Number.isNaN(date.getTime())) {
    throw new TypeError('date must be a valid Date, timestamp, or ISO date string');
  }
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    if (date.getUTCFullYear() !== year || date.getUTCMonth() + 1 !== month || date.getUTCDate() !== day) {
      throw new TypeError('date must be a valid Date, timestamp, or ISO date string');
    }
  }
  return date;
}

export function formatThaiDate(value, options = {}) {
  if (!isPlainDateOptions(options)) throw new TypeError('options must be a plain object');
  const date = toDate(value);
  let formatter;
  try {
    formatter = new Intl.DateTimeFormat('th-TH', { ...options });
  } catch {
    throw new RangeError('options contain unsupported Intl.DateTimeFormat values');
  }
  return formatter.format(date);
}
